export const HTTP_BASE_URL =
  process.env.VUE_APP_HTTP_BASE_URL || `${window.location.origin}/api`;
